module.exports = __webpack_public_path__ + "img/hz_20.fffb9df8.jpg";